import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ClienteModel } from 'src/app/models/cliente';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { InfoArrend } from 'src/app/interfaces/info-arrend';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { BodyPolizas } from 'src/app/interfaces/body_Polizas';
import { ResponsePolizas } from 'src/app/interfaces/response_Polizas';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { TIEMPO_INACTIVO, INFO_ARRENDAMIENTOS, COTIZACION_PAUSA } from 'src/app/routes.constants';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit, OnDestroy {
  botonDesactivado: boolean = false;

  @ViewChild('nombreCliente') nombreCliente!: ElementRef;
  @ViewChild('numCelular') numCelular!: ElementRef;
  @ViewChild('tipoDoc') tipoDoc!: ElementRef;
  @ViewChild('cedulaCliente') cedulaCliente!: ElementRef;
  @ViewChild('flexCheckAutoriza') flexCheckAutoriza2!: ElementRef;

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  checador: any;
  saliendo: boolean = false;
  isMouseMove: any;
  sessionId: string = '';
  responsePoliza!: ResponsePolizas;
  leadId: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {
        if (this.formulario.get("nombreCliente")?.value !== '' &&
          this.formulario.get("numCelular")?.value !== '' &&
          this.formulario.get("cedulaCliente")?.value !== '') {
          console.log('Mouse inactivo');
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.datosClienteHome.nombreCliente = this.formulario.get("nombreCliente")?.value.split(' ')[0];
          this.datosClienteHome.nombreCliente = this.formulario.get("cedulaCliente")?.value;
          this.datosClienteHome.celularCliente = this.formulario.get("numCelular")?.value;
          this.datosClienteHome.tipoIdentificacion = this.formulario.get("tipoDoc")?.value;
          this.datosGenerales.Cliente = this.datosClienteHome;

          this.parametro = JSON.stringify(this.datosGenerales);

          this.router.navigate([TIEMPO_INACTIVO, { codigoAsesor: this.codasesor, porcPll: '5', msnPll: 'Inactividad en llenar datos', infoViaje: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  private datosClienteHome: ClienteModel = {
    cedulaCliente: '',
    celularCliente: '',
    nombreCliente: '',
    tipoIdentificacion: ''
  };

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  private envioPoliza: BodyPolizas = {
    getTenantPolicies: false,
    productFamily: "",
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  }

  private campoValidados: number = 0;
  private parametro: string = '';
  celularPattern = environment.PATTERN_CELULAR;
  ngSelectTI: string = 'C';
  json: string = '';
  jsonFinal: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  id: any;
  IdBitacora: string = '';

  setUtm_campaign: string = '';
  setUtm_content: string = '';
  setUtm_medium: string = '';
  setUtm_source: string = '';

  datosCliente: InfoArrend = {
    Set_utm_campaign: '',
    Set_utm_content: '',
    Set_utm_medium: '',
    Set_utm_source: '',
    SessionId: '',
    productFamily: '',
    getTenantPolicies: false,
    asesorCode: '',
    screenPercentage: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      }
    }
  };

  response!: ResponseServices;

  formulario: FormGroup = new FormGroup(
    {
      nombreCliente: new FormControl('', [Validators.required, Validators.maxLength(80)]),
      numCelular: new FormControl('', [
        Validators.required,
        Validators.min(100000),
        Validators.max(9999999999),
        Validators.pattern(this.celularPattern)
      ]),
      tipoDoc: new FormControl('C', [Validators.required]),
      cedulaCliente: new FormControl('', [
        Validators.required,
        Validators.min(100000),
        Validators.max(9999999999)
      ]),
      flexCheckAutoriza: new FormControl(false)
    }
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() codasesor: string = '';
  @Input() infoCliente?: string;
  @Input() codAsesor: string = '';
  @Input() bitacoraId: string = '';

  @Input() utm_campaign?: string = '';
  @Input() utm_content?: string = '';
  @Input() utm_medium?: string = '';
  @Input() utm_source?: string = '';

  ngOnInit(): void {
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    this.sessionId = this.getLocalStorage().toString();
    console.log('HOME NG' + this.sessionId);
    const paramInfoCliente = this.infoCliente;
    const utmValidador = this.utm_campaign;

    if (utmValidador !== undefined) {
      this.setUtm_campaign = this.utm_campaign !== undefined ? this.utm_campaign : '';
      this.setUtm_content = this.utm_content !== undefined ? this.utm_content : '';
      this.setUtm_medium = this.utm_medium !== undefined ? this.utm_medium : '';
      this.setUtm_source = this.utm_source !== undefined ? this.utm_source : '';
    }

    if (paramInfoCliente !== undefined) {
      this.json = paramInfoCliente;
      this.jsonFinal = atob(this.json);
      this.datosGenerales = JSON.parse(this.jsonFinal);

      this.formulario.get("nombreCliente")?.setValue(this.datosGenerales.Cliente.nombreCliente);
      this.formulario.get("cedulaCliente")?.setValue(this.datosGenerales.Cliente.cedulaCliente);
      this.formulario.get("numCelular")?.setValue(this.datosGenerales.Cliente.celularCliente);
      this.formulario.get("tipoDoc")?.setValue(this.datosGenerales.Cliente.tipoIdentificacion);
    }


    this.route.queryParamMap.subscribe((params: ParamMap) => {

      const infoCliente = params.get('infoCliente');
      const idLead = params.get('idLead');
      this.leadId = idLead || '';

      if (infoCliente !== null) {
        this.json = infoCliente;
        this.jsonFinal = atob(this.json);
        this.datosClienteHome = JSON.parse(this.jsonFinal);
      }

      // Log the values of the parameters

    });
  }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);

    if (this.id) {
      clearInterval(this.id);
    }
  }

  valNombre = false;
  valNombre2 = true;
  validacionNombre() {
    if (this.formulario.get("nombreCliente")?.value === '') {
      this.valNombre = !this.valNombre;
      this.valNombre2 = !this.valNombre2;
    } else {
      this.valNombre = false;
      this.valNombre2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get("numCelular")?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  valTipoIdent = false;
  valTipoIdent2 = true;
  validacionvalTipoIdent() {
    if (this.formulario.get("tipoDoc")?.value === '') {
      this.valTipoIdent = !this.valTipoIdent;
      this.valTipoIdent2 = !this.valTipoIdent2;
    } else {
      this.valTipoIdent = false;
      this.valTipoIdent2 = true;
    }
  }

  valIdent = false;
  valIdent2 = true;
  validacionvalIdent() {
    if (this.formulario.get("cedulaCliente")?.value === '') {
      this.valIdent = !this.valIdent;
      this.valIdent2 = !this.valIdent2;
    } else {
      this.valIdent = false;
      this.valIdent2 = true;
    }
  }

  get nombreNoValido() {
    return this.formulario.get("nombreCliente")?.invalid
      && this.formulario.get("nombreCliente")?.touched;
  }

  get tipoDocumentoNoValido() {
    return this.formulario.get("tipoDoc")?.invalid
      && this.formulario.get("tipoDoc")?.touched;
  }

  get documentoNoValido() {
    return this.formulario.get("cedulaCliente")?.invalid
      && this.formulario.get("cedulaCliente")?.touched;
  }

  get cedularNoValido() {
    return this.formulario.get("numCelular")?.invalid
      && this.formulario.get("numCelular")?.touched;
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  infoArrendamiento(): void {

    this.botonDesactivado = !this.botonDesactivado;
    this.campoValidados = 0;
    if (this.formulario.get("nombreCliente")?.value === '') {
      this.campoValidados = 0;
      Swal.fire('Ingrese el nombre del Cliente', '', 'error');
      this.nombreCliente.nativeElement.focus();
      return;
    }
    else {
      this.campoValidados++;
    }

    if (this.formulario.get("numCelular")?.value === '') {
      this.campoValidados = 0;
      Swal.fire('Ingrese el celular', '', 'error');
      this.numCelular.nativeElement.focus();
      return;
    }
    else {
      this.campoValidados++;
    }

    if (this.formulario.get("cedulaCliente")?.value === '') {
      this.campoValidados = 0;
      Swal.fire('Ingrese la cedula del cliente', '', 'error');
      this.cedulaCliente.nativeElement.focus();
      return;
    }
    else {
      this.campoValidados++;
    }

    if (this.formulario.get("tipoDoc")?.value === '') {
      this.campoValidados = 0;
      Swal.fire('Ingrese el tipo de documento', '', 'error');
      this.tipoDoc.nativeElement.focus();
      return;
    }
    else {
      this.campoValidados++;
    }

    if (this.campoValidados === 4) {
      this.datosClienteHome.nombreCliente = this.formulario.get("nombreCliente")?.value.split(' ')[0];
      this.datosClienteHome.cedulaCliente = this.formulario.get("cedulaCliente")?.value;
      this.datosClienteHome.celularCliente = this.formulario.get("numCelular")?.value;
      this.datosClienteHome.tipoIdentificacion = this.formulario.get("tipoDoc")?.value;
      this.datosGenerales.Cliente = this.datosClienteHome
      this.parametro = JSON.stringify(this.datosGenerales);

      this.datosCliente.Set_utm_campaign = this.setUtm_campaign;
      this.datosCliente.Set_utm_content = this.setUtm_content;
      this.datosCliente.Set_utm_medium = this.setUtm_medium;
      this.datosCliente.Set_utm_source = this.setUtm_source;

      this.datosCliente.SessionId = this.sessionId;
      this.datosCliente.productFamily = "Arrendamientos";
      this.datosCliente.screenPercentage = "5";
      this.datosCliente.getTenantPolicies = true;


      if (this.codasesor !== 'undefined') {
        this.datosCliente.asesorCode = this.codasesor;
      }

      if (this.codasesor !== '') {
        this.datosCliente.asesorCode = this.codasesor;
      }
      else {
        this.codasesor = '';
        this.datosCliente.asesorCode = this.codasesor;
      }

      this.datosCliente.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("nombreCliente")?.value.split(' ')[0];
      this.datosCliente.productsConfigurationData.PolicyHolder.MobilePhone = this.formulario.get("numCelular")?.value.toString();
      this.datosCliente.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
      this.datosCliente.productsConfigurationData.Tenant.DocumentNumber = this.formulario.get("cedulaCliente")?.value.toString();
      this.datosCliente.productsConfigurationData.Tenant.DocumentType = this.formulario.get("tipoDoc")?.value;

      this._dataLayerService.logEvent("ecommerce_step_1", "Arrendamiento", "Inicio Arrendamiento", this.sessionId);

      const resquesBody = { ...this.datosCliente, ...(this.leadId !== '' && { leadId: this.leadId }) };

      this.orquestadorService.postOrquestadorHome(resquesBody).
        subscribe(
          (data) => {
            this.responsePoliza = data;
            this.IdBitacora = this.responsePoliza.data.bitacoraId === null ? '' : this.responsePoliza.data.bitacoraId;
            this.responsePoliza.data.leadId = this.leadId === '' ? this.responsePoliza.data.leadId : this.leadId;

            this.envioPoliza.getTenantPolicies = true;
            this.envioPoliza.productFamily = 'Arrendamiento';
            this.envioPoliza.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("nombreCliente")?.value.split(' ')[0];
            this.envioPoliza.productsConfigurationData.PolicyHolder.MobilePhone = this.formulario.get("numCelular")?.value.toString();
            this.envioPoliza.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;

            if (this.responsePoliza.data.tenant !== true) {
              this.router.navigate([INFO_ARRENDAMIENTOS, { codigoAsesor: this.codasesor, idLead: this.responsePoliza.data.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
            }
            else {
              this.router.navigate([COTIZACION_PAUSA, { codigoAsesor: this.codasesor, porcPll: '5', msnPll: 'Tipo de Propiedad comercial seleccionada.', idLead: this.responsePoliza.data.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
            }
          }
        );
    }

  }
}
